import { cn } from "../../../utils/useFunctions";
import AnalysisTableThree from "../component/analysisTable/analysisTableThree";
import PdfFooter from "../component/pdf.c.footer";
import PdfHeader from "../component/pdf.c.header";
import { PdfHeaderText } from "../component/pdf.c.headerText";
import PdfLine from "../component/pdf.c.line";
import { STYLE_PAGE } from "../styles/pdf.style";

function PdfPageOverviewSix({ page }) {
  return (
    <div
      style={{
        backgroundImage: `url(/images/bg_pdf.svg)`,
        backgroundRepeat: "no-repeat",
        backgroundPosition: "bottom right",
      }}
      className={cn(STYLE_PAGE)}
    >
      <PdfHeader />
      <PdfLine />
      <PdfHeaderText />
      <AnalysisTableThree />
      <PdfFooter page={page} />
    </div>
  );
}

export default PdfPageOverviewSix;
